import Icon, { IconsVariant } from "./Icon";
import Tooltip from "@/Components/Tooltip/Tooltip";
import { cn } from "@/shared/utils/cn";

interface IconToolTipProps {
  text?: string;
  backgroundNone?: boolean;
  variants?: IconsVariant;
  className?: string;
}

const IconToolTip = ({
  text = "Tooltip",
  backgroundNone = false,
  variants,
  className,
}: IconToolTipProps) => {
  return (
    <Tooltip content={text}>
      <div
        className={cn(
          "flex cursor-pointer items-center justify-center rounded-full p-4 transition-all duration-250",
          !backgroundNone && "hover:bg-grey focus:bg-grey active:bg-grey"
        )}
      >
        <Icon className={cn("size-8", className)} variants={variants} />
      </div>
    </Tooltip>
  );
};

export default IconToolTip;
